/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTimesheetsRouteImport } from './routes/_app/timesheets'
import { Route as AppTimeoffRouteImport } from './routes/_app/timeoff'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppProjectsRouteImport } from './routes/_app/projects'
import { Route as AppPeopleRouteImport } from './routes/_app/people'
import { Route as AppInvoicesRouteImport } from './routes/_app/invoices'
import { Route as AppFinanceRouteImport } from './routes/_app/finance'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppTimesheetsIndexRouteImport } from './routes/_app/timesheets.index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects.index'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices.index'
import { Route as AppFinanceIndexRouteImport } from './routes/_app/finance.index'
import { Route as AppTimesheetsShadowRouteImport } from './routes/_app/timesheets.shadow'
import { Route as AppTimesheetsAdminRouteImport } from './routes/_app/timesheets.admin'
import { Route as AppProjectsIdRouteImport } from './routes/_app/projects.$id'
import { Route as AppInvoicesNewRouteImport } from './routes/_app/invoices.new'
import { Route as AppInvoicesIdRouteImport } from './routes/_app/invoices.$id'
import { Route as AppFinanceNewRouteImport } from './routes/_app/finance.new'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppTimesheetsRoute = AppTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeoffRoute = AppTimeoffRouteImport.update({
  id: '/timeoff',
  path: '/timeoff',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleRoute = AppPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesRoute = AppInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceRoute = AppFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppTimesheetsIndexRoute = AppTimesheetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTimesheetsRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectsRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInvoicesRoute,
} as any)
const AppFinanceIndexRoute = AppFinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppTimesheetsShadowRoute = AppTimesheetsShadowRouteImport.update({
  id: '/shadow',
  path: '/shadow',
  getParentRoute: () => AppTimesheetsRoute,
} as any)
const AppTimesheetsAdminRoute = AppTimesheetsAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppTimesheetsRoute,
} as any)
const AppProjectsIdRoute = AppProjectsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppProjectsRoute,
} as any)
const AppInvoicesNewRoute = AppInvoicesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppInvoicesRoute,
} as any)
const AppInvoicesIdRoute = AppInvoicesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppInvoicesRoute,
} as any)
const AppFinanceNewRoute = AppFinanceNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppFinanceRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/analytics': typeof AppAnalyticsRoute
  '/finance': typeof AppFinanceRouteWithChildren
  '/invoices': typeof AppInvoicesRouteWithChildren
  '/people': typeof AppPeopleRoute
  '/projects': typeof AppProjectsRouteWithChildren
  '/settings': typeof AppSettingsRoute
  '/timeoff': typeof AppTimeoffRoute
  '/timesheets': typeof AppTimesheetsRouteWithChildren
  '/finance/new': typeof AppFinanceNewRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/timesheets/admin': typeof AppTimesheetsAdminRoute
  '/timesheets/shadow': typeof AppTimesheetsShadowRoute
  '/finance/': typeof AppFinanceIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/timesheets/': typeof AppTimesheetsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/analytics': typeof AppAnalyticsRoute
  '/people': typeof AppPeopleRoute
  '/settings': typeof AppSettingsRoute
  '/timeoff': typeof AppTimeoffRoute
  '/': typeof AppIndexRoute
  '/finance/new': typeof AppFinanceNewRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/timesheets/admin': typeof AppTimesheetsAdminRoute
  '/timesheets/shadow': typeof AppTimesheetsShadowRoute
  '/finance': typeof AppFinanceIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/timesheets': typeof AppTimesheetsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/finance': typeof AppFinanceRouteWithChildren
  '/_app/invoices': typeof AppInvoicesRouteWithChildren
  '/_app/people': typeof AppPeopleRoute
  '/_app/projects': typeof AppProjectsRouteWithChildren
  '/_app/settings': typeof AppSettingsRoute
  '/_app/timeoff': typeof AppTimeoffRoute
  '/_app/timesheets': typeof AppTimesheetsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/finance/new': typeof AppFinanceNewRoute
  '/_app/invoices/$id': typeof AppInvoicesIdRoute
  '/_app/invoices/new': typeof AppInvoicesNewRoute
  '/_app/projects/$id': typeof AppProjectsIdRoute
  '/_app/timesheets/admin': typeof AppTimesheetsAdminRoute
  '/_app/timesheets/shadow': typeof AppTimesheetsShadowRoute
  '/_app/finance/': typeof AppFinanceIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/timesheets/': typeof AppTimesheetsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/analytics'
    | '/finance'
    | '/invoices'
    | '/people'
    | '/projects'
    | '/settings'
    | '/timeoff'
    | '/timesheets'
    | '/finance/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/projects/$id'
    | '/timesheets/admin'
    | '/timesheets/shadow'
    | '/finance/'
    | '/invoices/'
    | '/projects/'
    | '/timesheets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/analytics'
    | '/people'
    | '/settings'
    | '/timeoff'
    | '/'
    | '/finance/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/projects/$id'
    | '/timesheets/admin'
    | '/timesheets/shadow'
    | '/finance'
    | '/invoices'
    | '/projects'
    | '/timesheets'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/_app/analytics'
    | '/_app/finance'
    | '/_app/invoices'
    | '/_app/people'
    | '/_app/projects'
    | '/_app/settings'
    | '/_app/timeoff'
    | '/_app/timesheets'
    | '/_app/'
    | '/_app/finance/new'
    | '/_app/invoices/$id'
    | '/_app/invoices/new'
    | '/_app/projects/$id'
    | '/_app/timesheets/admin'
    | '/_app/timesheets/shadow'
    | '/_app/finance/'
    | '/_app/invoices/'
    | '/_app/projects/'
    | '/_app/timesheets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timesheets': {
      id: '/_app/timesheets'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof AppTimesheetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timeoff': {
      id: '/_app/timeoff'
      path: '/timeoff'
      fullPath: '/timeoff'
      preLoaderRoute: typeof AppTimeoffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people': {
      id: '/_app/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AppPeopleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices': {
      id: '/_app/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance': {
      id: '/_app/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AppFinanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timesheets/': {
      id: '/_app/timesheets/'
      path: '/'
      fullPath: '/timesheets/'
      preLoaderRoute: typeof AppTimesheetsIndexRouteImport
      parentRoute: typeof AppTimesheetsRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppProjectsRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppInvoicesRoute
    }
    '/_app/finance/': {
      id: '/_app/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof AppFinanceIndexRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/timesheets/shadow': {
      id: '/_app/timesheets/shadow'
      path: '/shadow'
      fullPath: '/timesheets/shadow'
      preLoaderRoute: typeof AppTimesheetsShadowRouteImport
      parentRoute: typeof AppTimesheetsRoute
    }
    '/_app/timesheets/admin': {
      id: '/_app/timesheets/admin'
      path: '/admin'
      fullPath: '/timesheets/admin'
      preLoaderRoute: typeof AppTimesheetsAdminRouteImport
      parentRoute: typeof AppTimesheetsRoute
    }
    '/_app/projects/$id': {
      id: '/_app/projects/$id'
      path: '/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AppProjectsIdRouteImport
      parentRoute: typeof AppProjectsRoute
    }
    '/_app/invoices/new': {
      id: '/_app/invoices/new'
      path: '/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AppInvoicesNewRouteImport
      parentRoute: typeof AppInvoicesRoute
    }
    '/_app/invoices/$id': {
      id: '/_app/invoices/$id'
      path: '/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AppInvoicesIdRouteImport
      parentRoute: typeof AppInvoicesRoute
    }
    '/_app/finance/new': {
      id: '/_app/finance/new'
      path: '/new'
      fullPath: '/finance/new'
      preLoaderRoute: typeof AppFinanceNewRouteImport
      parentRoute: typeof AppFinanceRoute
    }
  }
}

interface AppFinanceRouteChildren {
  AppFinanceNewRoute: typeof AppFinanceNewRoute
  AppFinanceIndexRoute: typeof AppFinanceIndexRoute
}

const AppFinanceRouteChildren: AppFinanceRouteChildren = {
  AppFinanceNewRoute: AppFinanceNewRoute,
  AppFinanceIndexRoute: AppFinanceIndexRoute,
}

const AppFinanceRouteWithChildren = AppFinanceRoute._addFileChildren(
  AppFinanceRouteChildren,
)

interface AppInvoicesRouteChildren {
  AppInvoicesIdRoute: typeof AppInvoicesIdRoute
  AppInvoicesNewRoute: typeof AppInvoicesNewRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
}

const AppInvoicesRouteChildren: AppInvoicesRouteChildren = {
  AppInvoicesIdRoute: AppInvoicesIdRoute,
  AppInvoicesNewRoute: AppInvoicesNewRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
}

const AppInvoicesRouteWithChildren = AppInvoicesRoute._addFileChildren(
  AppInvoicesRouteChildren,
)

interface AppProjectsRouteChildren {
  AppProjectsIdRoute: typeof AppProjectsIdRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppProjectsRouteChildren: AppProjectsRouteChildren = {
  AppProjectsIdRoute: AppProjectsIdRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppProjectsRouteWithChildren = AppProjectsRoute._addFileChildren(
  AppProjectsRouteChildren,
)

interface AppTimesheetsRouteChildren {
  AppTimesheetsAdminRoute: typeof AppTimesheetsAdminRoute
  AppTimesheetsShadowRoute: typeof AppTimesheetsShadowRoute
  AppTimesheetsIndexRoute: typeof AppTimesheetsIndexRoute
}

const AppTimesheetsRouteChildren: AppTimesheetsRouteChildren = {
  AppTimesheetsAdminRoute: AppTimesheetsAdminRoute,
  AppTimesheetsShadowRoute: AppTimesheetsShadowRoute,
  AppTimesheetsIndexRoute: AppTimesheetsIndexRoute,
}

const AppTimesheetsRouteWithChildren = AppTimesheetsRoute._addFileChildren(
  AppTimesheetsRouteChildren,
)

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppFinanceRoute: typeof AppFinanceRouteWithChildren
  AppInvoicesRoute: typeof AppInvoicesRouteWithChildren
  AppPeopleRoute: typeof AppPeopleRoute
  AppProjectsRoute: typeof AppProjectsRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRoute
  AppTimeoffRoute: typeof AppTimeoffRoute
  AppTimesheetsRoute: typeof AppTimesheetsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppFinanceRoute: AppFinanceRouteWithChildren,
  AppInvoicesRoute: AppInvoicesRouteWithChildren,
  AppPeopleRoute: AppPeopleRoute,
  AppProjectsRoute: AppProjectsRouteWithChildren,
  AppSettingsRoute: AppSettingsRoute,
  AppTimeoffRoute: AppTimeoffRoute,
  AppTimesheetsRoute: AppTimesheetsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
